import { useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '../../../shared/api.js';
import { useApiMutation } from '../../../shared/useApi.js';

const KEY = ['settings', 'devices'];

export function useDevices(params = {}) {
  return useQuery({
    queryKey: [...KEY, params],
    queryFn: async () => {
      const { data } = await api.get('/devices', { params });
      return data?.devices || data?.data || data || [];
    },
    staleTime: 30_000
  });
}

export function useCreateDevice() {
  const qc = useQueryClient();
  return useApiMutation({
    mutationFn: (body) => api.post('/devices', body).then((r) => r.data),
    successMessage: 'تم إنشاء الجهاز',
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY })
  });
}

export function useUpdateDevice() {
  const qc = useQueryClient();
  return useApiMutation({
    mutationFn: ({ id, body }) => api.patch(`/devices/${id}`, body).then((r) => r.data),
    successMessage: 'تم حفظ الجهاز',
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY })
  });
}

export function useDeleteDevice() {
  const qc = useQueryClient();
  return useApiMutation({
    mutationFn: (id) => api.delete(`/devices/${id}`).then((r) => r.data),
    successMessage: 'تم حذف الجهاز',
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY })
  });
}
